import { useNavigate } from "react-router-dom";
import { logout } from "./login_halper";
import MenuFrame from "../frames/menu_frame";
import { Backdrop, CircularProgress } from "@mui/material";

export default function Logout() {
    const navigate = useNavigate();

    logout().then((_) => {
        navigate("/");
    }).catch((err) => {
        console.error(err);
    })

    return <MenuFrame>
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={true} >
            <CircularProgress color="inherit" />
        </Backdrop>
    </MenuFrame>
}
